import { IState } from '../../store';

export function selectBlackFridayPromoDatesText(state: IState) {
  return state.featureToggle.newbuildingBlackFridaySettings.promoDatesText;
}
